<template>
  <div class="md:hidden mb-8">
    <button class="w-full flex items-center justify-between text-xs text-white bg-primary-red py-3 px-4" @click="onOpenOverlay">
      <strong>{{ translations.filtersMobileLabel }}
        <template v-if="activeCategoriesCount > 0">
          ({{ activeCategoriesCount }})
        </template>
      </strong>
      <FilterIcon
        class="icon fill-current"
        width="20px"
        height="20px"
      />
    </button>

    <transition enter-active-class="transition-all duration-500 ease-out"
                leave-active-class="transition-all duration-500 ease-out"
                enter-class="opacity-0 invisible"
                enter-to-class="opacity-100 visible"
                leave-class="opacity-100 visible"
                leave-to-class="opacity-0 invisible"
    >
      <div v-show="showFilterOverlay"
           class="mobile-filters fixed top-0 left-0 h-full bg-primary-light text-sm z-40 w-full"
      >
        <div v-if="showFilterOverlay" class="h-full">
          <!-- Header -->
          <div class="relative text-center p-4 bg-primary-light z-30" style="height: 56px;">
            <span>{{ translations.filterMobileLabel }}</span>
            <button class="absolute right-0 text-primary-red mx-4 font-bold" @click="onClearFilters">
              {{ translations.clearAllMobileText }}
            </button>
          </div>

          <div
            ref="categoriesOverlay"
            class="relative w-full overflow-x-hidden overflow-y-scroll"
            style="height: calc(100% - 112px);"
          >
            <!-- Filters -->
            <filter-single
              v-for="category in categories"
              :key="category.slug"
              :category="category"
            />
          </div>

          <!-- Footer -->
          <button
            class="w-full bg-primary-red text-white text-center p-4 mt-auto"
            style="height: 56px;"
            @click="onCloseOverlay"
          >
            <span>{{ totalCountText }}</span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, computed } from 'vue'

import searchFactory from '@/compositions/search/SearchFactory'
import searchConfig from '@/compositions/search/SearchConfiguration'
import searchQueryState from '@/compositions/search/SearchQuery'

import FilterIcon from '@/assets/icons/filter.svg'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import FilterSingle from './SearchCategorySingleMobileRecipe.vue'

export default {
  components: {
    FilterSingle,
    FilterIcon
  },
  setup() {
    const { totalCount } = searchFactory.useSearchResult()
    const { getActiveConfig } = searchConfig.searchConfigurationUse()
    const { removeAllCategories, activeCategories } = searchQueryState.searchQueryUse()
    const showFilterOverlay = ref(false)
    const categoriesOverlay = ref(null)

    function onOpenOverlay() {
      showFilterOverlay.value = true
      disableBodyScroll(categoriesOverlay.value)
    }

    function onCloseOverlay() {
      showFilterOverlay.value = false
      enableBodyScroll(categoriesOverlay.value)
    }

    function onClearFilters() {
      // Reset filters
      removeAllCategories()
      showFilterOverlay.value = false
      enableBodyScroll(categoriesOverlay.value)
    }

    return {
      activeCategoriesCount: computed(() => activeCategories.value.length),
      categories: computed(() => getActiveConfig().categories),
      translations: computed(() => getActiveConfig().translations),
      totalCountText: computed(() => getActiveConfig().translations.totalCountMobileMessage.replace('{0}', totalCount.value)),

      categoriesOverlay,
      showFilterOverlay,

      onOpenOverlay,
      onCloseOverlay,
      onClearFilters
    }
  }
}
</script>

<style>
/* 1792x828px at 326ppi */
@media only screen
    and (device-width: 414px)
    and (device-height: 896px)
    and (-webkit-device-pixel-ratio: 2) {
      .mobile-filters .sticky.bottom-0 {
        padding-bottom: 40px;
      }
}
/* 2436x1125px at 458ppi */
@media only screen
  and (device-width: 375px)
  and (device-height: 812px)
  and (-webkit-device-pixel-ratio: 3) {
    .mobile-filters .sticky.bottom-0 {
      padding-bottom: 40px;
    }
}
/* 2688x1242px at 458ppi */
@media only screen
  and (device-width: 414px)
  and (device-height: 896px)
  and (-webkit-device-pixel-ratio: 3) {
    .mobile-filters .sticky.bottom-0 {
      padding-bottom: 40px;
    }
}
</style>
